import { useState } from 'react';
import { FlaskConical, Scale, FileText } from 'lucide-react';
import Layout from '../components/Layout';
import LabReport from '../components/misc/LabReport';
import WeighBridgeSlip from '../components/misc/WeighBridgeSlip';
import InvoiceGenerator from '../components/misc/InvoiceGenerator';

const TABS = [
  { id: 'lab-report', label: 'Lab Report', icon: FlaskConical },
  { id: 'weigh-bridge', label: 'Weigh Bridge Slip', icon: Scale },
  { id: 'invoice', label: 'Invoice', icon: FileText },
];

export default function Misc() {
  const [activeTab, setActiveTab] = useState('lab-report');

  return (
    <Layout>
      <div data-testid="misc-page">
        {/* Tab Header */}
        <div className="flex items-center gap-1 mb-6 border-b border-slate-200 pb-1">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                data-testid={`misc-tab-${tab.id}`}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  flex items-center gap-2 px-4 py-2.5 rounded-t-xl text-sm font-medium transition-all duration-200
                  ${isActive
                    ? 'bg-amber-50 text-amber-700 border-b-2 border-amber-500'
                    : 'text-slate-500 hover:text-slate-700 hover:bg-slate-50'
                  }
                `}
              >
                <Icon className="w-4 h-4" strokeWidth={1.5} />
                {tab.label}
              </button>
            );
          })}
        </div>

        {/* Tab Content */}
        {activeTab === 'lab-report' && <LabReport />}
        {activeTab === 'weigh-bridge' && <WeighBridgeSlip />}
        {activeTab === 'invoice' && <InvoiceGenerator />}
      </div>
    </Layout>
  );
}
